import { Component, OnInit, Input } from '@angular/core';
import { Meeting } from '../../../../models/meeting';
import { MeetingsService } from '../../../../services/meetings.service';
import { AgentUtility } from '../../../../util';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';

@Component({
  selector: 'app-client-meetings-history',
  templateUrl: './client-meetings-history.component.html',
  styleUrls: ['./client-meetings-history.component.css']
})
export class ClientMeetingsHistoryComponent implements OnInit {

  meetings:Meeting[]
  length: number = 0;

  @Input() meetingId:number;

  constructor(private meetingsService:MeetingsService, private activateRoute:ActivatedRoute, private routerModule: RouterModule) { }

  ngOnInit() {
    let id = this.activateRoute.snapshot.params["id"];
    this.meetingsService.getClientMeetings(id).subscribe(data => {
      this.meetings = data.data;
      this.length = this.meetings.length;
    })
  }

}
